import { render } from "./SearchResultsCompany.vue?vue&type=template&id=5a1ec741&scoped=true"
import script from "./SearchResultsCompany.vue?vue&type=script&lang=js"
export * from "./SearchResultsCompany.vue?vue&type=script&lang=js"

import "./SearchResultsCompany.vue?vue&type=style&index=0&id=5a1ec741&lang=scss&scoped=true"

import exportComponent from "../../../../../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-5a1ec741"]])

export default __exports__